/**
 * Lightweight project module types (Brian 2026-09-12 — §8.10 v1: CRUD +
 * document store, NOT a PM suite). These mirror the server Project schema
 * additive columns from migration 20260912190000_project_module_v1 and are
 * the data seam for the AI pre-fill fast-follow (AI proposes, human confirms,
 * source cited — same pattern as cert OCR / §8.7 capacity extraction).
 */

/** §4.3 stakeholder list row — mirrored from the construction-plan shape. */
export interface ProjectStakeholder {
  name: string;
  role: string;
  org: string;
  phone?: string;
}

/** §4.4.5 plan-consideration / §4.3 stakeholder fields on Project (additive). */
export interface ProjectLightweightFields {
  structureInfo: string | null;
  stakeholders: ProjectStakeholder[] | null;
  notes: string | null;
}

export type ProjectDocType = 'BOM' | 'CD' | 'RFDS' | 'SCOPE' | 'PERMIT' | 'OTHER';

export interface ProjectDocument {
  id: number;
  companyId: number;
  projectId: number;
  originalName: string;
  storedName: string;
  docType: ProjectDocType | string;
  mimeType: string;
  sizeBytes: number;
  createdAt: string;
}

export interface ProjectRecord {
  id: number;
  companyId: number;
  name: string;
  siteAddress: string;
  carrierName?: string | null;
  carrierId?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  status: string;
  teamId?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  /** §8.10 v1 lightweight fields */
  structureInfo?: string | null;
  stakeholders?: ProjectStakeholder[] | null;
  notes?: string | null;
  documents?: ProjectDocument[];
  team?: { id: number; name: string } | null;
  _count?: { documents: number; constructionPlans: number; jhas: number };
}

/** Create/PATCH payload for the lightweight project form. */
export interface ProjectFormPayload {
  name: string;
  siteAddress: string;
  carrierName?: string;
  carrierId?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  startDate?: string;
  endDate?: string;
  teamId?: number | null;
  structureInfo?: string | null;
  stakeholders?: ProjectStakeholder[] | null;
  notes?: string | null;
}

/** Empty stakeholder row template for the repeatable form rows. */
export const EMPTY_STAKEHOLDER: ProjectStakeholder = { name: '', role: '', org: '', phone: '' };